import { Loader } from '@mindbaz/ui-v2';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Gone from 'pages/Common/Gone';
import NoFound from 'pages/Common/NoFound';

import DailyReport from './DailyReport';
import Dashboards from './Dashboards';
import Features from './Features';
import SafeSend from './SafeSend';
import Layout from '../modules/Layout';

const PrivateRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/dashboards" element={<Dashboards />} />
            <Route path="/" element={<Features />} />
            <Route path="/snapshot" element={<DailyReport />} />
            <Route path="/safesend" element={<SafeSend />} />
            <Route path="/gone" element={<Gone />} />
            <Route path="*" element={<NoFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </Suspense>
  );
};

export default PrivateRoutes;
